var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeCart,
          expression: "closeCart",
        },
      ],
      staticClass: "ticketHeader js-ticketHeader",
    },
    [
      _vm.enableTicketShop && _vm.isTicketNavItemEnabled && !_vm.isFacelift
        ? [
            _c("div", { staticClass: "ticketHeader__item" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.shopUrl,
                    title: _vm.$t("shopNav.titles.toTheTickets"),
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ticketHeader__itemIcon" },
                    [_c("Tickets")],
                    1
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "ticketHeader__itemTitle" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("shopNav.tickets")) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isFacelift && _vm.isLoginNavItemEnabled
        ? _c(
            "div",
            {
              staticClass: "ticketHeader__item",
              class: { "ticketHeader__item--loggedIn": _vm.loggedIn },
            },
            [
              _c(
                "a",
                {
                  staticClass: "ticketHeader__text",
                  attrs: { href: _vm.loginSystem, title: _vm.loginTitle },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ticketHeader__itemIcon" },
                    [_c("Login")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "ticketHeader__itemTitle" },
                    [
                      _vm.sessionDTO !== null && !_vm.user
                        ? [_vm._v("\n          ...\n        ")]
                        : !_vm.isGuest && _vm.loggedIn
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.user.firstName) +
                                " " +
                                _vm._s(_vm.user.lastName) +
                                "\n        "
                            ),
                          ]
                        : _vm.isGuest
                        ? [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("shopNav.guest")) +
                                "\n        "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("shopNav.logIn")) +
                                "\n        "
                            ),
                          ],
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.isGuest
                ? [
                    _c("div", { staticClass: "ticketHeader__logout" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "#", title: _vm.$t("shopNav.logOut") },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.logout.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("shopNav.logOut")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.enableTicketShop && _vm.isCartNavItemEnabled
        ? [
            _c(
              "div",
              {
                staticClass:
                  "js-tickerHeader__cart tickerHeader__cart tickerHeader__cart--mobile ticketHeader__item",
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "ticketHeader__text",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.toggleBox.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "ticketHeader__itemIcon" },
                      [
                        _c("Cart"),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "ticketHeader__itemIconCount" },
                          [_vm._v(_vm._s(_vm.totalProductCount))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.remainingTimeInSeconds > 0 &&
            _vm.ticketConfigurations.length > 0
              ? [
                  _c(
                    "p",
                    {
                      staticClass:
                        "ticketHeader__time ticketHeader__time--mobile tickerHeader__cart js-timeHeader__cart",
                      class: {
                        "miniCart--visible-mobileTimeHeader": _vm.boxOpen,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("shopNav.reserved"))
                      ),
                      _c("br"),
                      _vm._v(
                        " " +
                          _vm._s(_vm.cartTimeoutString) +
                          " " +
                          _vm._s(_vm.$t("shopNav.minutes")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "tickerHeader__cart ticketHeader__item ticketHeader__item--cart",
                class: { "miniCart--visible": _vm.isCartOpenFacelift },
                attrs: {
                  "aria-label": _vm.$t("shopNav.cartAriaLabel"),
                  "aria-expanded": _vm.isCartOpenFacelift.toString(),
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ticketHeader__iconCountContainer",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.toggleCartFacelift.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "ticketHeader__itemIcon" },
                      [
                        _vm.isFacelift
                          ? [_c("MiniCartFaceliftIcon")]
                          : [_c("Cart")],
                        _vm._v(" "),
                        !_vm.isFacelift ||
                        (_vm.isFacelift && _vm.totalProductCount)
                          ? [
                              _c(
                                "span",
                                { staticClass: "ticketHeader__itemIconCount" },
                                [_vm._v(_vm._s(_vm.totalProductCount))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.isFacelift
                  ? [
                      _c("p", { staticClass: "ticketHeader__itemTitle" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("shopNav.shoppingCart")) +
                            "\n        "
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "miniCart modal-container js-cart-flyout",
                    class: {
                      "miniCart--visible": _vm.boxOpen,
                      "miniCart--open": _vm.isCartOpenFacelift,
                    },
                  },
                  [
                    _vm.boxOpen
                      ? _c("div", {
                          staticClass: "modal-mask modal-mask--shop",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.toggleBox.apply(null, arguments)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "miniCart__box" },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "miniCart__headline",
                            class: {
                              ticketHeader__headlineNoTime:
                                _vm.isFacelift &&
                                !(
                                  _vm.remainingTimeInSeconds > 0 &&
                                  _vm.ticketConfigurations.length > 0
                                ),
                            },
                          },
                          [
                            !(
                              _vm.remainingTimeInSeconds > 0 &&
                              _vm.ticketConfigurations.length > 0
                            )
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("shopNav.shoppingCart")) +
                                      "\n            "
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.remainingTimeInSeconds > 0 &&
                            _vm.ticketConfigurations.length > 0 &&
                            _vm.isFacelift
                              ? [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "ticketHeader__time ticketHeader__item--hiddenMobile",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("shopNav.reserved"))
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "ticketHeader__cartTimeoutString",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.cartTimeoutString) +
                                              " " +
                                              _vm._s(
                                                _vm.$t("shopNav.minutes")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.loading ? [_c("spinner")] : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "miniCart__content",
                            staticClass: "miniCart__content",
                            class: {
                              "overflow-y-scroll":
                                _vm.miniCartContentIsOverflowingY,
                            },
                          },
                          [
                            _vm.ticketConfigurations.length === 0 ||
                            _vm.cart === null
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "miniCart__contentHeadline",
                                    },
                                    [
                                      _c("p", { staticClass: "h4" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("shopNav.emptyShoppingCart")
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cart !== null
                              ? [
                                  _vm._l(
                                    _vm.ticketConfigurations,
                                    function (ticketConfiguration) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            key: ticketConfiguration.id,
                                            staticClass: "miniCart__ticket",
                                            class: {
                                              "miniCart__ticket--special":
                                                ticketConfiguration.specialProduct,
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "miniCart__ticketPrice",
                                              },
                                              [
                                                ticketConfiguration.specialProduct
                                                  ? [
                                                      ticketConfiguration.promotion
                                                        ? [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "miniCart__ticketPriceAmount miniCart__ticketPriceAmount--reduced",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatPrice"
                                                                      )(
                                                                        ticketConfiguration
                                                                          .product
                                                                          .price *
                                                                          ticketConfiguration.quantity
                                                                      )
                                                                    ) +
                                                                    " €\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "miniCart__reducedTicketPriceAmount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatPrice"
                                                                      )(
                                                                        ticketConfiguration
                                                                          .promotion
                                                                          .price *
                                                                          ticketConfiguration.quantity
                                                                      )
                                                                    ) +
                                                                    " €\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "miniCart__ticketPriceAmount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatPrice"
                                                                      )(
                                                                        ticketConfiguration
                                                                          .product
                                                                          .price *
                                                                          ticketConfiguration.quantity
                                                                      )
                                                                    ) +
                                                                    " €\n                        "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                    ]
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "miniCart__ticketPriceAmount",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatPrice"
                                                                )(
                                                                  ticketConfiguration.calculatedProductPrice *
                                                                    ticketConfiguration.quantity
                                                                )
                                                              ) +
                                                              " €\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "miniCart__ticketTitle",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$tm(
                                                        ticketConfiguration.product,
                                                        "descriptionWebShop"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                                ticketConfiguration.event
                                                  ? _c("small", [
                                                      _vm._v(
                                                        "\n                      - " +
                                                          _vm._s(
                                                            _vm.$tm(
                                                              ticketConfiguration.event,
                                                              "descriptionExternal"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "miniCart__ticketText",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t("shopNav.amount")
                                                    ) +
                                                    _vm._s(
                                                      ticketConfiguration.quantity
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            ticketConfiguration.slot
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "miniCart__ticketText miniCart__ticketText--bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t("shopNav.slot")
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            ticketConfiguration.slot
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "miniCart__ticketText",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatTimeString"
                                                          )(
                                                            ticketConfiguration
                                                              .slot.printStart,
                                                            _vm.userLanguage
                                                          )
                                                        ) +
                                                        " -\n                    " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatTimeString"
                                                          )(
                                                            ticketConfiguration
                                                              .slot.printEnd,
                                                            _vm.userLanguage
                                                          )
                                                        ) +
                                                        " Uhr\n                    "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ticketModal__itemSlotText",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDateString"
                                                              )(
                                                                ticketConfiguration
                                                                  .slot
                                                                  .printStart,
                                                                _vm.userLanguage
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                        new Date(
                                                          ticketConfiguration.slot.printStart
                                                        ).getDate() !==
                                                        new Date(
                                                          ticketConfiguration.slot.printEnd
                                                        ).getDate()
                                                          ? [
                                                              _vm._v(
                                                                "\n                        -  " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatDateString"
                                                                    )(
                                                                      ticketConfiguration
                                                                        .slot
                                                                        .printEnd,
                                                                      _vm.userLanguage
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "miniCart__ticketRemove",
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.removeFromCart(
                                                      ticketConfiguration
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.links.removeArticle"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    }
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isFacelift ? _c("hr") : _vm._e(),
                            _vm._v(" "),
                            _vm.ticketConfigurations.length > 0 &&
                            _vm.cart !== null
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "miniCart__total" },
                                    [
                                      _vm.cart.cartPromotions.length
                                        ? [
                                            _vm._l(
                                              _vm.cart.cartPromotions,
                                              function (promotionCode) {
                                                return [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "miniCart__reducedTotalAmount",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "cart.promotionCode"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            promotionCode.code
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          "- " +
                                                            _vm._s(
                                                              promotionCode.discountValue
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              promotionCode.discountType
                                                            )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.cart
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "miniCart__totalAmount",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("formatPrice")(
                                                    _vm.cart.sum
                                                  )
                                                ) + " €"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "miniCart__totalText" },
                                        [_vm._v(_vm._s(_vm.$t("shopNav.sum")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "miniCart__totalSubtext",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("shopNav.sumSubText"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "miniCart__actions" },
                              [
                                _vm.ticketConfigurations.length === 0 ||
                                _vm.cart === null
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button miniCart__submit",
                                          attrs: { href: _vm.shopUrl },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.links.toTicketShop"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                          _vm.isFacelift
                                            ? [_c("ShoppingCartIcon")]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button miniCart__delete",
                                          attrs: {
                                            href: "#",
                                            title: _vm.$t(
                                              "global.links.emptyShoppingCart"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.emptyCart.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [_c("Trash")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button miniCart__submit",
                                          attrs: { href: _vm.cartUrl },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "global.links.toShoppingCart"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                          _vm.isFacelift
                                            ? [_c("ShoppingCartIcon")]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          2
                        ),
                      ],
                      2
                    ),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _vm.remainingTimeInSeconds > 0 &&
            _vm.ticketConfigurations.length > 0 &&
            !_vm.isFacelift
              ? [
                  _c(
                    "p",
                    {
                      staticClass:
                        "ticketHeader__time ticketHeader__item--hiddenMobile",
                    },
                    [
                      _vm._v("\n        " + _vm._s(_vm.$t("shopNav.reserved"))),
                      _c("br"),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.cartTimeoutString) +
                          " " +
                          _vm._s(_vm.$t("shopNav.minutes")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }